import "./style.scss";

export const Button = ({ children, onClick, disabled = false }) => {
  return (
    <button className={`button ${disabled ? "disabled" : ""}`} onClick={onClick}>
      {children}
    </button>
  );
};
